import { IConfigurationParameters } from 'ui-toolkit/authentication/types/AuthenticationConfig';
import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';

export const ApplicationConfigAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getConfig: build.query<IConfigurationParameters, void>({
      query: () => ({
        url: '/timber/api/internal/spa/config',
        method: 'GET',
      }),
      providesTags: () => [{ type: eAPITags.Config }],
    }),
  }),
});

export const { useGetConfigQuery } = ApplicationConfigAPI;
